import React, { lazy } from 'react';
import { createRoot } from 'react-dom/client';
import type { IFaqBlockProps } from './faq-block';

const FaqBlock = lazy(async () => import('./faq-block'));

const el = '.fa-component--faq-block';
const DOM = document.querySelectorAll(el);

const render = function () {
    if (DOM) {
        DOM.forEach((component) => {
            const props = JSON.parse(component.getAttribute('data-props')!) as IFaqBlockProps;

            createRoot(component).render(<FaqBlock {...props} />);
        });
    }
};

export default {
    render,
};
